// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2aaw1","notes":"Notes_notes__p9V6S"};